const reductionMisc = {
  getRequireModes: function () {
    return ['require', 'remove'];
  },

  getTypes: function () {
    return [
      '2+_equal',
      '3+_equal',
      '2+2_equal',
      '2+2_or_3+_equal',
      '2+_in_row',
      '3+_in_row',
      '4+_in_row',
      '2+_equal_in_row',
      '3+_equal_in_row',
      '1+_odd',
      '2+_odd',
      '3+_odd',
      '4+_odd',
      '2+_odd_in_next',
      '3+_odd_in_next',
      '4+_odd_in_next',
      '1+_pair',
      '2+_pair',
      '3+_pair',
      '4+_pair',
      '2+_pair_in_next',
      '3+_pair_in_next',
      '4+_pair_in_next',
      'ascending',
      'descending',
    ];
  },
};

export default reductionMisc;
